import {gql} from '@apollo/client';

const FRAGMENT_COMMENT_ITEM = gql`
  fragment CommentItem on CommentType {
    id
    content
    createdAt
    isLiked
    user {
      id
      fullname
      avatar {
        id
        path
      }
      client {
        id
      }
    }
  }
`;

export const QUERY_COMMENT_LIST = gql`
  query CommentList($forumId: ID) {
    commentList(forum: $forumId) {
      ...CommentItem
    }
  }
  ${FRAGMENT_COMMENT_ITEM}
`;

export const MUTATION_COMMENT_SAVE = gql`
  mutation CommentSave($input: CommentSaveInput!) {
    commentSave(input: $input) {
      obj {
        ...CommentItem
        forum {
          id
          commentsCount
        }
      }
    }
  }
  ${FRAGMENT_COMMENT_ITEM}
`;

export const MUTATION_COMMENT_LIKE = gql`
  mutation CommentLike($input: CommentLikeInput!) {
    commentLike(input: $input) {
      obj {
        id
        isLiked
        forum {
          id
          likesCount
        }
      }
    }
  }
`;
